var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calc_ads"},[_c('a',{attrs:{"href":"https://hardbg.ru?refcode=VMMM","target":"_blank"}},[(_vm.show)?_c('img',{staticClass:"grey lighten-2",attrs:{"src":_vm.ads1}}):_vm._e(),(!_vm.show)?_c('img',{staticClass:"grey lighten-2",attrs:{"src":_vm.ads2}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }